import GolfIcon from '@/components/GolfIcon';
import ChatList from '@/components/messages/ChatList';
import { useUserProfile } from '@/context/UserProfileContext';
import { Capacitor } from '@capacitor/core';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

const ChatListPage: React.FC = () => {
  const { profile } = useUserProfile();
  const [activeChat, setActiveChat] = useState<string | null>(null);
  const history = useHistory();
  const { t } = useTranslation();

  const handleSelectChat = (chatId: string) => {
    if (Capacitor.isNativePlatform()) {
      // On native platforms, navigate to the chat view page
      history.push(`/messages/${chatId}`);
    } else {
      // On web, just update the active chat
      setActiveChat(chatId);
    }
  };

  const handleNewChat = () => {
    // Handle new chat creation logic
    console.log('Creating new chat');
  };

  return (
    <IonPage>
      <IonHeader className='ion-no-border'>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton text='' defaultHref="/dashboard" />
          </IonButtons>
          <IonTitle>{t('messages')}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={handleNewChat}>
              <GolfIcon name="message-add" className="size-6 dark:invert" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {profile && (
          <ChatList
            userId={profile.userId}
            activeChat={activeChat}
            onSelectChat={handleSelectChat}
            onNewChat={handleNewChat}
          />
        )}
      </IonContent>
    </IonPage>
  );
};

export default ChatListPage;
